import { Component } from '@angular/core';

@Component({
  selector: 'hsc-unauthorized-page',
  template: `
    <div class="flex h-[calc(100vh-453px)] items-center justify-center">
      Oops, it doesn't appear you're authorized to access this site
    </div>
  `,
})
export class UnauthorizedPage {}
